export const textsQuantities = [
  new Array(5).fill('text'),
  new Array(5).fill('text'),
];
